kdx-hero-slide-item { width: 100%; }
.kdx-hero-slide-item {    
    height: 100%;    
    color: #FFF;
    position: relative;
    background-color: $heroCarouselOverlayMobile;
        
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        z-index: 2;
        background: $heroCarouselOverlay;
    }

    .hero-content {
        height: 100%;
        width: 50%;
        padding: 100px 20px 160px 0;
        position: relative;
        z-index: 3;
    }
    .heading {
        color: $heroCarouselText;
        margin: 0 0 16px 0;
    }
    .subheading {
        @include text-size(24);
        @include line-height(33);
        margin: 0 0 24px 0;
        color: $heroCarouselText;
    }
    .hero-ctas {
        display: flex;
        align-items: center;

        .btn + kdx-arrow-link {
            .arrow-link { margin-left: 24px; }
        }

        .arrow-link, .arrow-link.white-link {
            @include text-size(15);
            color: $heroCarouselArrowLinkText !important;

            &:hover, &:focus { color: $heroCarouselArrowLinkTextHover !important; }
        }
    }
    .hero-img {
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        width: auto;
        height: 100%;
        object-fit: cover;
        object-position: 50% 20%;
        padding-right: 80px;
        max-width: 50%;
    }    
}

@include media-breakpoint-down(md) {
  .kdx-hero-slide-item {
    .hero-img {
      height: 320px;
    }
  }
}

@include media-breakpoint-down(lg) {
    .kdx-hero-slide-item {
        display: flex;
        flex-direction: column-reverse;

        &:before { display: none; }
        .hero-img {            
            width: 100%;
            max-width: 100%;
            height: 320px;
            object-position: top left;
        }
        .hero-content {
            width: 100%;
            padding: 24px 0 100px 0;
            margin-top: 340px;
            text-align: center;
        }
        .subheading {
            @include text-size(16);
            @include line-height(24);
        }
        .hero-ctas {
            flex-direction: column;

            .btn { 
                margin-bottom: 24px; 
                width: 80%;
            }
            .btn + kdx-arrow-link {
                .arrow-link { margin-left: 0; }
            }
        }

    }
}

  @include media-breakpoint-down(xl) {
    .kdx-hero-slide-item {
      .hero-img {
        padding-right: 0;
      }
    }
  }
